import { createAction } from "@reduxjs/toolkit";

import {
  createSubscriptionActionTypes,
  editSubscriptionActionTypes,
  setPaymentSubscriptionsActionTypes,
  setPaymentSubscriptionsPortionActionTypes,
  getSubscriptionActionTypes,
  getSubscriptionsByPostActionTypes,
  getPortionSubscriptionActionTypes,
  getSubscriptionDetailsActionTypes,
  deleteMySubscriptionActionTypes,
  changeSubscriptionPositionActionTypes,
  updateSubscriptionsActionTypes,
} from "./actionTypes";

export const createSubscription = createAction(
  createSubscriptionActionTypes.request,
  (payload) => ({ payload }),
);

export const createSubscriptionSuccess = createAction(
  createSubscriptionActionTypes.success,
  (payload) => ({ payload }),
);

export const createSubscriptionFailure = createAction(
  createSubscriptionActionTypes.failure,
  (error) => ({ payload: error }),
);

export const createSubscriptionReset = createAction(
  createSubscriptionActionTypes.reset,
  (payload) => ({ payload }),
);

export const getSubscription = createAction(getSubscriptionActionTypes.request);

export const getSubscriptionSuccess = createAction(
  getSubscriptionActionTypes.success,
  (payload) => ({ payload }),
);

export const getSubscriptionFailure = createAction(
  getSubscriptionActionTypes.failure,
  (error) => ({ payload: error }),
);

export const editSubscription = createAction(
  editSubscriptionActionTypes.request,
  (payload) => ({ payload }),
);
export const editSubscriptionSuccess = createAction(
  editSubscriptionActionTypes.success,
  (payload) => ({ payload }),
);
export const editSubscriptionFailure = createAction(
  editSubscriptionActionTypes.failure,
  (error) => ({ payload: error }),
);
export const editSubscriptionReset = createAction(
  editSubscriptionActionTypes.reset,
);

export const getPaymentSubscriptions = createAction(
  setPaymentSubscriptionsActionTypes.request,
);

export const setPaymentSubscriptionsSuccess = createAction(
  setPaymentSubscriptionsActionTypes.success,
  (payload) => ({ payload }),
);

export const setPaymentSubscriptionsFailure = createAction(
  setPaymentSubscriptionsActionTypes.failure,
  (error) => ({ payload: error }),
);

export const setPortionPaymentSubscriptions = createAction(
  setPaymentSubscriptionsPortionActionTypes.request,
);

export const setPortionPaymentSubscriptionsSuccess = createAction(
  setPaymentSubscriptionsPortionActionTypes.success,
  (payload) => ({ payload }),
);

export const setPortionPaymentSubscriptionsFailure = createAction(
  setPaymentSubscriptionsPortionActionTypes.failure,
  (payload) => ({ payload }),
);

export const getSubscriptionDetails = createAction(
  getSubscriptionDetailsActionTypes.request,
  (payload) => ({ payload }),
);

export const getSubscriptionDetailsSuccess = createAction(
  getSubscriptionDetailsActionTypes.success,
  (payload) => ({ payload }),
);

export const getSubscriptionDetailsFailure = createAction(
  getSubscriptionDetailsActionTypes.failure,
  (payload) => ({ payload }),
);

export const getSubscriptionDetailsReset = createAction(
  getSubscriptionDetailsActionTypes.reset,
  (payload) => ({ payload }),
);

export const getPortionSubscriptions = createAction(
  getPortionSubscriptionActionTypes.request,
);

export const getPortionSubscriptionsSuccess = createAction(
  getPortionSubscriptionActionTypes.success,
  (payload) => ({ payload }),
);

export const getPortionSubscriptionsFailure = createAction(
  getPortionSubscriptionActionTypes.failure,
  (payload) => ({ payload }),
);

export const getSubscriptionsByPost = createAction(
  getSubscriptionsByPostActionTypes.request,
  (payload) => ({ payload }),
);

export const getSubscriptionsByPostSuccess = createAction(
  getSubscriptionsByPostActionTypes.success,
  (payload) => ({ payload }),
);

export const getSubscriptionsByPostFailure = createAction(
  getSubscriptionsByPostActionTypes.failure,
  (payload) => ({ payload }),
);

export const getSubscriptionsByPostReset = createAction(
  getSubscriptionsByPostActionTypes.reset,
);

export const deleteMySubscription = createAction(
  deleteMySubscriptionActionTypes.request,
);

export const deleteMySubscriptionSuccess = createAction(
  deleteMySubscriptionActionTypes.success,
);

export const deleteMySubscriptionFailure = createAction(
  deleteMySubscriptionActionTypes.failure,
);

export const subscriptionsReset = createAction("subscriptions/reset");

export const changeSubscriptionPosition = createAction(
  changeSubscriptionPositionActionTypes.request,
  (payload) => ({ payload }),
);

export const changeSubscriptionPositionSuccess = createAction(
  changeSubscriptionPositionActionTypes.success,
  (payload) => ({ payload }),
);

export const changeSubscriptionPositionFailure = createAction(
  changeSubscriptionPositionActionTypes.failure,
  (payload) => ({ payload }),
);

export const updateSubscriptions = createAction(
  updateSubscriptionsActionTypes,
  (payload) => ({ payload }),
);
